import { type Plugin } from 'vue';
import { createRouter, createWebHistory, type RouteLocationRaw } from 'vue-router';

import { useAuthRefresh } from '../services/clients';
import { useSession } from '../services/composables';
import { useBreadcrumbStore } from '../stores';
import { type CorePluginOptions, defaultOptions } from './corePluginOptions';

export const setupRouter: (options?: Partial<CorePluginOptions>) => Plugin = (options?: Partial<CorePluginOptions>) => {
	const { authRefresh } = useAuthRefresh();
	const { checkSession, clearSession, isAuthenticated, isRefreshable, setSession } = useSession();
	const breadcrumbStore = useBreadcrumbStore();

	const router = createRouter({
		history: createWebHistory(),
		routes: options?.routes ?? defaultOptions.value.routes
	});

	router.beforeEach(async (to, _from): Promise<RouteLocationRaw | undefined> => {
		checkSession();

		if (!to.meta?.breadcrumbs) {
			breadcrumbStore.clearBreadcrumbs();
		}
		if (!isRefreshable.value) {
			clearSession();
			if (!['login', 'forgot-password','reset-password'].includes(to.name as string)) {
			  return {
				name: 'login',
				query: {
					redirect: to.fullPath
				}
			  };
			}
			return;
		}
		if (!isAuthenticated.value) {
			try {
				const response = await authRefresh();
				setSession(response);
				if (['login'].includes(to.name as string)) {
					return {
						name: 'root'
					};
				}
				return;
			}
			catch {
				clearSession();
				if (!['login'].includes(to.name as string)) {
					return {
						name: 'login',
					  	query: {
							redirect: to.fullPath
						}
					};
				}
			}
		}
		if (to.name === 'login') {
			return {
				name: 'root'
			};
		}
		return;
	});

	return router;
};